export const SET_GENERATOR = "SET_GENERATOR";
export const SET_GENERATOR_LIST = "SET_GENERATOR_LIST";